import { useRouteError } from "@remix-run/react";
import Page404 from "~/pages/404";

export async function loader() {
  throw new Response(null, {
    status: 404,
    statusText: "Not Found",
  });
}

export function ErrorBoundary() {
  const error = useRouteError();
  return <Page404 error={error} />;
}
